module.exports = __webpack_public_path__ + "img/climate.f18c1970.svg";